import Axios from "axios";

export class FuncionarioService {

    listado(params, op) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/${op}/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data, op) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/${op}/nuevo`, data).then(res => res.data);
    }

    editar(data, op) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/${op}/editar`, data).then(res => res.data);
    }

    consultar(id, op, idp, tipo = null) {
        let url = `${process.env.REACT_APP_URL_BACK}/ficha/${op}/consulta/${id}/${idp}`;
        if(tipo) {
            url = `${url}/${tipo}`;
        }
        return Axios.get(url).then(res => res.data);
    }

    eliminar(id, op, idp) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/${op}/eliminar/${id}/${idp}`).then(res => res.data);
    }

    descargar(id, op) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/${op}/reporte/${id}`, {
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Expires': 0 },
            params: {
                t: new Date().getTime(),
            },
            responseType: 'blob'
        }).then(async res => res.data);
    }
}
